/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AddressComponentMapper } from './address-component-mapper.interface';
import { CountryAddressComponentMapper } from './impl/country-address-component.mapper';
import { CityAddressComponentMapper } from './impl/city-address-component.mapper';
import { PostalCodeAddressComponentMapper } from './impl/postal-code-address-component.mapper';
import { EmptyAddressComponentMapper } from './impl/empty-address-component.mapper';
import { StateAddressComponentMapper } from './impl/state-address-component.mapper';

export class AddressComponentMapperFactory {

  public createMapper(addressComponent: google.maps.GeocoderAddressComponent): AddressComponentMapper {
    const types: string [] = addressComponent.types;
    if (!types || types.length === 0) {
      return new EmptyAddressComponentMapper(addressComponent);
    }
    if (this.isCountryAddressComponent(types)) {
      return new CountryAddressComponentMapper(addressComponent);
    }
    if (this.isCityAddressComponent(types)) {
      return new CityAddressComponentMapper(addressComponent);
    }
    if (this.isPostalCodeAddressComponent(types)) {
      return new PostalCodeAddressComponentMapper(addressComponent);
    }
    if (this.isStateAddressComponent(types)) {
      return new StateAddressComponentMapper(addressComponent);
    }
    return new EmptyAddressComponentMapper(addressComponent);
  }

  private isCountryAddressComponent(types: string[]): boolean {
    return types.includes('country');
  }

  private isCityAddressComponent(types: string[]): boolean {
    return types.includes('locality');
  }

  private isPostalCodeAddressComponent(types: string[]): boolean {
    return types.includes('postal_code');
  }

  private isStateAddressComponent(types: string[]): boolean {
    return types.includes('administrative_area_level_1');
  }
}
